module.exports = __webpack_public_path__ + "static/img/star-on.45dd5470.png";